import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { ZenIconsEnum } from '../../../zentility/_shared/_enums/zen-icons.enum';

@Component({
  selector: 'app-stats-cards',
  standalone: true,
  imports: [CommonModule, MatCardModule],
  template: `
    <div class="stats-grid">
      <mat-card class="stat-card">
        <div class="stat-content">
          <div class="stat-info">
            <p class="stat-label">Electricity</p>
            <p class="stat-value">
              {{ stats.electric | number }} <span class="stat-unit">kWh</span>
            </p>
          </div>
          <div class="stat-icon electric">
            <i class="material-symbols-rounded">{{ZenIconsEnum.ELECTRIC}}</i>
          </div>
        </div>
      </mat-card>

      <mat-card class="stat-card">
        <div class="stat-content">
          <div class="stat-info">
            <p class="stat-label">Gas</p>
            <p class="stat-value">
              {{ stats.gas | number }} <span class="stat-unit">Dth</span>
            </p>
          </div>
          <div class="stat-icon nat-gas">
            <i class="material-symbols-rounded">{{ZenIconsEnum.NAT_GAS}}</i>
          </div>
        </div>
      </mat-card>

      <mat-card class="stat-card">
        <div class="stat-content">
          <div class="stat-info">
            <p class="stat-label">Needs Review</p>
            <p class="stat-value">
              {{ stats.reviewCount }} <span class="stat-unit">Bills</span>
            </p>
          </div>
          <div class="stat-icon review">
            <i class="material-symbols-rounded">error_outline</i>
          </div>
        </div>
      </mat-card>

      <mat-card class="stat-card">
        <div class="stat-content">
          <div class="stat-info">
            <p class="stat-label">Ready</p>
            <p class="stat-value">
              {{ stats.approvedCount }} <span class="stat-unit">Bills</span>
            </p>
          </div>
          <div class="stat-icon ready">
            <i class="material-symbols-rounded">check_circle</i>
          </div>
        </div>
      </mat-card>
    </div>
  `,
  styleUrl: './stats-cards.component.scss'
})
export class StatsCardsComponent {
  @Input() stats = { electric: 0, gas: 0, reviewCount: 0, approvedCount: 0 };
  ZenIconsEnum = ZenIconsEnum;
}
